import {Component, ViewChild} from '@angular/core';
import {AlertController, App, Nav, Platform} from 'ionic-angular';

import {ScreenOrientation} from "@ionic-native/screen-orientation";
import {StatusBar} from "@ionic-native/status-bar";
import {SplashScreen} from "@ionic-native/splash-screen";
import {Keyboard} from '@ionic-native/keyboard';

import {LogadoService} from '../../providers/logado-service';
import {DataService} from '../../providers/data-service';

import {TGoogleAnalytic, Util} from '../util';
// joga o jquery para o vendor.js
import * as $ from 'jquery';
import {CONFIG} from "../config";
import {AFTER_LOGIN, AFTER_LOGOUT, CLOSE_PAGE} from "../import";
import {TAction, TProdutoTipo, TCheckinFlague, TCentralTipo, TCarsale, TAcessoFind, TDevicerScan} from "../enum";
import {StorageService} from "../../providers/storage-service";
import {NavRepository} from "../../repositories/nav-repository";
import {PushService} from "../../providers/push-service";
import {MessageService} from "../../providers/message-service";
import {ChavecoMenuPage} from "../../pages/sync/chaveco-menu/chaveco-menu";
import {ProfileAuthPage} from "../../pages/sync/profile-auth/profile-auth";
import {Deeplinks} from "@ionic-native/deeplinks";
import {CarbookService} from "../../providers/carbook-service";
import {WebsiteSpotPage} from "../../pages/sync/website-spot/website-spot";
import {HotspotService} from "../../providers/hotspot-service";
import {ModalActionPage} from "../../pages/sync/modal-action/modal-action";
import {MeritumMenuPage} from "../../pages/sync/meritum-menu/meritum-menu";
import {SupportMenuPage} from "../../pages/sync/support-menu/support-menu";
import {WarningMenuPage} from "../../pages/sync/warning-menu/warning-menu";
//import {ProfileMenuPage} from "../../pages/sync/profile-menu/profile-menu";
import {Ndef,     NFC} from "@ionic-native/nfc";
import {DeviceDetectorService} from 'ngx-device-detector';
import {LoadingErroPage} from '../../pages/sync/loading-erro/loading-erro';
import {NetworkInterface} from '@ionic-native/network-interface';


window["$"] = $;
window["jQuery"] = $;

@Component({
    selector: 'handapp-main',
    templateUrl: 'handapp-main.html',
    providers: [HotspotService]
})

export class HandappMain {

    @ViewChild(Nav) navCtrl: Nav;

    config: any;

    titulo: string;
    result: string;

    started: boolean = false;

    requestLoop: boolean = false;

    supportShow: boolean = false;
    escutarBool: boolean = false;
    escutarWait: boolean = false;
    escutarOnde: TDevicerScan;

    appjson = {

        searching: false,

        changed: true,

        briding: {handle: 0, searching: false},
        checkin: null,

        hotwork: null,

        devicerIpad: false,

        justifys: null,
        projetos: null,
        departas: null,

        _firsterro: true,

    };

    nicknamer: string = '';

    constructor(
        //public navCtrl: NavController,
        public statusBar: StatusBar, public splashScreen: SplashScreen,
                public screenOrientation: ScreenOrientation, public platform: Platform, public app: App,
                public util: Util, public alertCtrl: AlertController,
                public carbookService: CarbookService, public hotspotService: HotspotService,
                public deeplinks: Deeplinks,
                public dataService: DataService, public storageService: StorageService,
                public pushService: PushService,
                public networkInterface: NetworkInterface,
                private nfc: NFC, private ndef: Ndef,
                public deviceService: DeviceDetectorService,
                private keyboard: Keyboard, public navRepository: NavRepository,
                public logadoService: LogadoService,
                public messageService: MessageService) {

        this.config = CONFIG;

        this.initializeApp();

    }

    ngOnInit() {

        window['handappMainInstance'] = this;

    }



    initializeApp() {

        let referrer = (document.referrer &&
            document.referrer.indexOf('10.0.0.') == -1 &&
            document.referrer.indexOf('localhost') == -1 &&
            document.referrer.indexOf('lorean.com.br') == -1 &&
            document.referrer.indexOf('lorean.app') == -1 &&
            document.referrer.indexOf('facebook.com') == -1
        );

        if (referrer) this.dataService.set('referrer', document.referrer);


        this.platform.ready().then(() => {

            // configs para nativos
            if ( this.util.nativeApp()) this.handappNative();
            if (!this.util.nativeApp()) this.handappBrowser();

        });

    }

    handappNative() {

        //Screenshot Detect
        document.addEventListener('screenshot',
            (event) => {

                if (this.dataService.get('tabselected') == 1 && !this.appjson.checkin.PaybookID) {

                    let onOkey = (okey, that, data) => that.dismiss();
                    let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'screenshot', onOkey, onOkey, false, null, null)};
                    this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

                }

            }, false);


        //# ORIENTATION SETTING
        //if (this.deviceService.isTablet() || devicerIpad) this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE)
        //else 
        this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
  

        //# KEYBOARD SETTING
        this.keyboard.hideKeyboardAccessoryBar(true);
        this.keyboard.disableScroll(false);
        this.statusBar.styleDefault();
        //this.splashScreen.hide();

        // Verify new version installed the ionic pro
        this.storageService.get('DEVICE-RELEASE')
            .subscribe(devicerSoft => {

                if (devicerSoft && devicerSoft != CONFIG.data.version) {
                    this.util.toastSimply('Lorean atualizado para versão ' + CONFIG.data.version, 6000);
                }

                this.storageService.set('DEVICE-RELEASE', CONFIG.data.version).subscribe();

                this.handappPrepare();
                
                this.escutarNear();
                this.escutarTela(TDevicerScan.dsEntraki);

            });

    }

    handappBrowser() {

        this.storageService.get('BROWSER-SERIAL')
            .subscribe(data => {

                if (!data) {
                    data = parseInt((Math.random() * 10000000000000000000).toString(), 10);
                    this.storageService.set('BROWSER-SERIAL', data).subscribe();
                }

                this.util.deviceSerial(data);

                this.handappPrepare();

            });

    }

    handappPrepare() {

        this.deeplink();

        this.pageNavigate(window.location.search); // get | params

        this.storageService.get('BRIDGE-SERVER').subscribe(data => {

            this.storageService.get('MONITOR-AUTH').subscribe((monitorAuth) => {
            
                this.storageService.get('DEVICER-IPAD').subscribe((devicerIpad) => {

                    this.storageService.get('LOGADO-SESSAO').subscribe((logadoSessao) => {

                        this.storageService.get('LOADED-NOTIFICA').subscribe((pushloaded) => {

                            this.storageService.get('LOADED-LOCATION').subscribe(geolloaded => {

                                this.util.deviceInfo().subscribe((device) => {

                                        CONFIG.paths.bridge = data ? data : CONFIG.paths.bridgeMainway;
                                        CONFIG.data.device = device;

                                        //#MonitorAuth - Login diretona rede local
                                        if (monitorAuth && logadoSessao) {
                                            logadoSessao = null;
                                            this.logadoService.logout();
                                        }

                                        // Grava na memoria a sessão
                                        // para nao ficar pegando do BD toda hora.
                                        this.appjson.hotwork = monitorAuth;
                                        this.appjson.devicerIpad = devicerIpad;
                                        this.dataService.set('MONITOR-AUTH', monitorAuth);
                                        this.dataService.set('DEVICER-IPAD', devicerIpad);
                                        this.dataService.set('LOGADO-SESSAO', logadoSessao);
                                        this.dataService.set('LOADED-NOTIFICA', !!pushloaded);
                                        this.dataService.set('LOADED-LOCATION', !!geolloaded);

                                        this.handappInit();

                                    },
                                    erro => {

                                        this.util.alertSimply(erro);

                                    })


                            });

                        });

                    });

                });
                
            });

        });

    }

    handappInit() {

        //Desktop-Menu || #MonitorAuth - Login diretona rede local
        let desktopTela = this.deviceService.isTablet();
        let monitorAuth = this.appjson.hotwork;
        
        if (desktopTela || monitorAuth) {
            this.splashScreen.hide();
            this.navRepository.afterLogout(this.navCtrl, AFTER_LOGOUT).subscribe();
            return;
        }

        let params = '';
        if (this.nicknamer) params = '&Nicknamer=' + this.nicknamer;


        let loading = this.util.loadingDots('Iniciando...');
        loading.present();

        this.logadoService.started(TAction.acInit, null, params)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    /** DEVELOP - Forced external app **/
                    CONFIG.data.brandap = (!data.Brandeds || !data.Brandeds.length ? null : data.Brandeds[0]);

                    // ** Google Analytics - Create ** //
                    let googleAnalyticsId = CONFIG.data.brandap && CONFIG.data.brandap.ContratoGA ? CONFIG.data.brandap.ContratoGA : CONFIG.spotus.Interface.googleAnalyticsId;
                    this.util.googleCreate(googleAnalyticsId);

                    // ** Google Analytics - Send ** //
                    this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Handapp Start', '/handapp-main');

                    if (data.Action == '#APPSTORE#' || data.Action == '#APPIONIC#') {
                        this.navRepository.afterLogin(this.navCtrl, AFTER_LOGOUT).subscribe();
                        return;
                    }

                    // ** Logado já esta autenticado ** //
                    let logadoSessao = this.dataService.get('LOGADO-SESSAO');
                    if (!logadoSessao) {
                        this.splashScreen.hide();
                        this.navRepository.afterLogout(this.navCtrl, AFTER_LOGOUT).subscribe();
                        return;
                    }

                    this.pushService.pushStart(true)
                        .finally(() => this.profileAuth(null))
                        .subscribe(data => {},erro => {});

                },
                erro => {

                    this.splashScreen.hide();
                    let anime = {animate: true, direction: 'back'};
                    let object = {etapa: 2, action: erro.Action, titulo: erro.Titulo, result: erro.Result};
                    this.navCtrl.setRoot(LoadingErroPage, object, anime);
                    // ->> ou esse
                    // this.app.getRootNavs()[0].setRoot(ProfileAuthPage, object, anime);
                    //this.navRepository.afterLogout(this.navCtrl, AFTER_LOGOUT).subscribe();

                });

    }

    escutarTela(escutarOnde: TDevicerScan) {

        this.escutarOnde = escutarOnde;

    }

    escutarScan() {
        
        // #GAMB - Para não causar o evento repetido se encostar muito rápido
        if (this.escutarWait) return;

        if (this.platform.is('android')) {
            if (this.escutarOnde == TDevicerScan.dsEntraki) this.util.toastSimply('Aproxime o celular para entrar.');
            return;
        }
        
        this.nfc
        .beginSession(
            // data => alert('D-:'+data),
            // erro => alert('E-:'+erro),
        )
        .subscribe(
            // data => alert('D:'+data),
            // erro => alert('E:'+erro),
        );

    }

    escutarLock() {

        this.nfc.makeReadOnly().then(() => alert('then')).catch(() => alert('erro'));

    }

    escutarSave(tipo: 'Hotspot' | 'Comanda', codigo: number) {

        let json = (tipo == 'Hotspot' ? {HotspotID: codigo} : {ComandaNoro: codigo});
        let text = JSON.stringify(json);
        let save = this.util.criptRede(text, true);
        
        let message = this.ndef.textRecord(save);
        this.nfc.write([message]).then(() => console.log('pronto')).catch(() => alert('erro'));
        
        this.nfc.readerMode(
            this.nfc.FLAG_READER.NFC_A | this.nfc.FLAG_READER.NO_PLATFORM_SOUNDS,
            nfcTag => alert('RM:'+JSON.stringify(nfcTag)),
            error => alert('NFC reader mode failed' + JSON.stringify(error))
        );

    }

    escutarNear() {

        let onNear = () => {

            this.escutarBool = true;
            
            let onScan = (data) => {

                // #GAMB - Para não chamar nada!
                if (!this.escutarOnde) return;

                // #GAMB - Para não causar o evento repetido se encostar muito rápido
                if (this.escutarWait) return;

                //{"isTrusted":false,"tag":{"id":[0],"techTypes":["android.nfc.tech.Ndef"],"type":"android.ndef.unknown","maxSize":0,"isWritable":false,"ndefMessage":[{"tnf":1,"type":[85],"id":[],"payload":[3,112,108,97,121,46,103,111,111,103,108,101,46,99,111,109,47,115,116,111,114,101,47,97,112,112,115,47,100,101,116,97,105,108,115,63,105,100,61,99,111,109,46,119,97,107,100,101,118,46,119,100,110,102,99,38,102,101,97,116,117,114,101,61,98,101,97,109]},{"tnf":4,"type":[97,110,100,114,111,105,100,46,99,111,109,58,112,107,103],"id":[],"payload":[99,111,109,46,119,97,107,100,101,118,46,119,100,110,102,99]}],"canMakeReadOnly":false}}
                if (!data || !data.tag || !data.tag.ndefMessage || !data.tag.ndefMessage[0]) return;
                let nfcload = data.tag.ndefMessage[0].payload;
                if (!nfcload) return;

                let nfcbase = this.nfc.bytesToString(nfcload).substring(3);
                if (!nfcbase) return;

                let isnan = isNaN(parseInt(nfcbase));
                let nfctext = (!isnan ? nfcbase : this.util.criptRede(nfcbase, false));
                if (!nfctext) return;

                let nfcerro = '';
                let nfcjson = JSON.parse(nfctext);

                if (!nfcerro && !nfcjson) nfcerro = 'JSON Inválido';
                if (!nfcerro && this.escutarOnde == TDevicerScan.dsEntraki && !nfcjson.HotspotID)   nfcerro = 'ENTRAKI - Etiqueta é uma comanda';
                if (!nfcerro && this.escutarOnde == TDevicerScan.dsWorkday && !nfcjson.ComandaNoro) nfcerro = 'WORKDAY - Etiqueta é um Hotspot';
                if (!nfcerro && this.escutarOnde == TDevicerScan.dsCheckin && !nfcjson.ComandaNoro) nfcerro = 'CHECKIN - Etiqueta é um Hotspot';
                if (!nfcerro && this.escutarOnde == TDevicerScan.dsComanda && !nfcjson.ComandaNoro) nfcerro = 'COMANDA - Etiqueta é um Hotspot';
                if (nfcerro) {
                    this.util.toastSimply(nfcerro);
                    return;
                }

                //escutarOnde: 'connect.scannfc' | 'workday.scannfc' || 'checkin.scannfc'
                this.messageService.get(TDevicerScan[this.escutarOnde]).next(nfctext);

                // #GAMB - Para não causar o evento repetido se encostar muito rápido
                this.escutarWait = true;
                setTimeout(() => this.escutarWait = false, 2000);

            };

            // this.nfc.addTagDiscoveredListener(nfcEvent => alert(JSON.stringify(nfcEvent)), fail => alert(JSON.stringify(fail))).subscribe(data => {
            //     alert(JSON.stringify(data));
            //     onScan(data);
            //     // if (data && data.tag && data.tag.id) {
            //     //     let tagId = this.nfc.bytesToHexString(data.tag.id);
            //     //     if (tagId) {
            //     //         this.nav.setRoot(PayerCard, { "TagID": tagId });
            //     //     } else {
            //     //         this.showToast(this.translate.instant('NFC_NOT_DETECTED'))
            //     //     }
            //     // }
            //     },
            //     erro => alert(JSON.stringify(erro))
            // );
    
    
            // this.nfc.addTagDiscoveredListener(function(nfcEvent) {
            //     this.nfc.connect('android.nfc.tech.IsoDep', 500).then(
            //         () => alert('connected to' + this.nfc.bytesToHexString(nfcEvent.tag.id)),
            //         (error) => alert('connection failed' + JSON.stringify(error))
            //     );
            // });
    
            this.nfc.addNdefListener(() => console.log('NFC-listen')).subscribe(
                data => onScan(data),
                erro => alert('Erro:' + JSON.stringify(erro)),
            );

            // this.nfc.addNdefFormatableListener(() => alert('NFC-listen-X'), data => onScan(data)).subscribe(
            //     data => onScan(data)
            //     //erro => alert('Erro:' + erro),
            // );

            // add a 2nd listener for the mime type
            // this.nfc.addMimeTypeListener('text/plain', okay => alert(JSON.stringify(okay)), fail => alert(JSON.stringify(fail))).subscribe(
            //     okay => alert(JSON.stringify(okay)), fail => alert(JSON.stringify(fail))
            // )

        };

        this.nfc.enabled()
            .then(
                () => onNear(),                 //SIM TEM SUPORTE NFC
                () => this.escutarBool = false, //NAO TEM SUPORTE NFC
            );
            
    }

    profileAuth(proauth) {
        
        let loading = this.util.loadingDots('Autenticando...');
        loading.present();

        this.logadoService.started(TAction.acAuth, proauth)
            .finally(() => {

                loading.dismiss();
                this.started = true;
                this.splashScreen.hide();

            })
            .subscribe(
                data => {

                    let logado = this.logadoService.getAuth();
                    if (!logado) {
                        this.util.alertSimply('LOGIN sem LOGADO');
                        return;
                    }

                    this.navRepository.afterLogin(this.navCtrl, AFTER_LOGIN).subscribe();

                    //Bridge - Verify States in started
                    //Quando entra no app pega o logado e verifica se esta em algum lugar
                    this.checkinCall(0);

                    //Bridge - Verify States in started
                    //Quando entra no app pega exibe Warnings                    
                    if (logado && logado.Warnings) this.util.modalopen(WarningMenuPage, 'alto', false, {etapa: 0}, {animate: false}).subscribe();
                },
                erro => {

                    let res = {body: erro};
                    this.handappAction(res);

                    //Muito dificil cair aqui
                    if (!erro.Action) {
                        let anime = {animate: true, direction: 'back'};
                        let object = {etapa: 2, action: erro.Action, titulo: erro.Titulo, result: erro.Result};
                        this.navCtrl.setRoot(LoadingErroPage, object, anime);
                    }

                });

    }

    handappAction(res) {


        //Alert Toast
        if (res.body.Toaste) {
            this.util.toastSimply(res.body.Toaste);
        }


        //Alert Message
        if (res.body.Alerta) {
            this.util.alertResult(res.body);
        }

        //Action Expira
        if (res.body && res.body.Logout == '#EXPIRADO#') {
            this.handappLogout();
        }

        //Action Store
        if (res.body.Action == '#APPSTORE#') {
            let anime = {animate: true, direction: 'back'};
            let object = {etapa: 3, action: res.body.Action, titulo: 'Nova Versão', result: 'Disponível na loja', versao: res.body.Versao};
            this.navCtrl.setRoot(LoadingErroPage, object, anime);
        }

        //Action Ionic
        if (res.body.Action == '#APPIONIC#') {
            let anime = {animate: true, direction: 'back'};
            let object = {etapa: 4, action: res.body.Action, titulo: 'Novo Release', result: 'Disponível no Deploy', versao: res.body.Versao, deploy: res.body.Deploy};
            this.navCtrl.setRoot(LoadingErroPage, object, anime);
        }

        //Pergunta se quer re-login com facebook
        if (res.body.Action == '#FACEBOOK#') {

            let object = {etapa: 0};
            this.app.getRootNavs()[0].setRoot(ProfileAuthPage, object).then(() => this.messageService.get('facebook.expired').next());

        }

    }

    handappLogout() {

        if (this.requestLoop) return;

        //'#EXPIRADO#'
        setTimeout(() => this.logadoService.logout(), 5000);
        this.navRepository.afterLogout(this.navCtrl, AFTER_LOGOUT).subscribe();
        
    }

    //Deeplink
    deeplink() {

        if (!this.platform.is('cordova')) {
            return;
        }

        this.deeplinks.route({}).subscribe(
            match => {
                // match.$route - the route we matched, which is the matched entry from the arguments to route()
                // match.$args - the args passed in the link
                // match.$link - the full link data
                // console.log('Successfully matched route', match);
            },
            nomatch => {
                // nomatch.$link - the full link data
                // console.error('Got a deeplink that didn\'t match', JSON.stringify(nomatch));

                if (nomatch && nomatch.$link) this.pageNavigate(nomatch.$link.queryString);

            });

    }

    //Hotkey
    setBridge(bridge: 'Bridge' | 'Mirror' | 'Classe') {

        let server = CONFIG.paths.bridgeMainway;
        if (bridge == 'Bridge') server = CONFIG.paths.bridgeMainway;
        if (bridge == 'Mirror') server = CONFIG.paths.bridgeSupport;
        if (bridge == 'Classe') server = CONFIG.paths.bridgeRededez;

        let value = (server == CONFIG.paths.bridgeMainway ? null : server);
    
        this.storageService.set('BRIDGE-SERVER', value).subscribe();
        CONFIG.paths.bridge = server;

    }

    //Hotkey - Ctrl+K
    setDevelop(key: string, event) {

        if (event) event.stopPropagation();

        let onFinish = (data) => {

            if (data != null && data.Keylock.toLowerCase() != 'devpass') return;

            let buttons: Array<any> = [];
            buttons.push({text: 'Cancelar', hole: 'cancel'});
            buttons.push({text: 'Pronto', hole: null, handler: (data) => this.setBridge(data)});
            let inputs = [
                {type: 'radio', label: 'Bridge', value: 'Bridge'},
                {type: 'radio', label: 'Mirror', value: 'Mirror'},
                {type: 'radio', label: '10.0.0.5', value: 'Classe'},
            ];
            this.alertCtrl.create({title: 'Server', inputs: inputs, buttons: buttons}).present();

        };

        // ***** KEYLOCK NOT ***** //
        let logado = this.logadoService.getAuth();
        if (logado && logado.Profile.ProfileTeam) {
            onFinish(null);
            return;
        }

        // ***** KEYLOCK YES ***** //
        let buttons: Array<any> = [];
        buttons.push({text: 'Cancelar', hole: 'cancel'});
        buttons.push({text: 'Pronto', hole: null, handler: (data) => onFinish(data)});
        let inputs = [{type: 'text', name: 'Keylock', placeholder: 'Keylock'}];
        this.alertCtrl.create({title: 'Develop', inputs: inputs, buttons: buttons}).present();

    }

    supportMenu(fab) {

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Novo',      handler: () => this.supportNovo('220.158.988-75')});
        buttons.push({text: 'View',      handler: () => this.supportWork()});
        buttons.push({text: 'Hide',      handler: () => this.supportHide()});
      //buttons.push({text: 'Cancelar', role: 'cancel', cssClass: this.util.sheetClass(true, true, 'food'), handler: () => this.textdata = null});
        this.util.sheetOpen(buttons, 'SUPPPORT');

    }

    supportHide() {

        //Hide Support Button Fab
        (window as any).handappMainInstance.supportShow = false;

    }

    supportNovo(rnid) {

        // let onNovo = (line) => {
        //     //Hide Support Button Fab
        //     (window as any).handappMainInstance.supportShow = false;

        //     let object = {etapa: -1, profile: line, hotspotID: 0, supports: null, selected: 0};
        //     this.util.navActive().push(SupportMenuPage, object, {animation: 'md-transition'});
        // };

        // let ghosterID = this.config.spotus.BrandedID;
        // this.profileRepository.profileFind(rnid, 'CPF', ProfileMenuPage, ghosterID)
        //    .subscribe(line => onNovo(line));

    }


    supportWork() {

        //Hide Support Button Fab
        this.supportShow = false;

        let logado = this.logadoService.getAuth();
        let object = {etapa: 0, profile: logado.Profile, hotspotID: 0, supports: null, selected: 0};
        this.navCtrl.push(SupportMenuPage, object, {animation: 'md-transition'});

    }

    fabClick(fab) {

        fab.close();

    }

    //APP-PUBLISH - nao esta usando onde chama
    pushModal() {

        this.pushService.getPermission().subscribe(
            data => {},
            erro => {

                let onPush = () => {};
                let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'pushnotifye', onPush, onPush, false, null, null)};
                this.util.modalopen(ModalActionPage, 'wide', true, objectData, null, null, onPush).subscribe();

            });

    }

    pushReceive(notification) {

        // Read na memoria ultima notificação para nao duplicar
        if (this.dataService.get('PUSH-DUPLICATE') == notification.additionalData.id) return;
        // Save na memoria ultima notificação para nao duplicar
        this.dataService.set('PUSH-DUPLICATE', notification.additionalData.id);

        //if (!this.started) // app fechado

        // Badge notifye update
        if (typeof notification.count != 'undefined') {

            let logado = this.logadoService.getAuth();
            if (logado.Aboutme) logado.Aboutme.NotifyeQtde = notification.count; // "badge" chega como "count"

        }

        // PushSilence Exemple
        if (notification.additionalData.tipo == TCentralTipo.ctCheckin && notification.additionalData.flag == TCheckinFlague.chCheckinEntra) {

            //ForcebookID
            let logado = this.logadoService.getAuth();
            let paybookID = (logado.Profile.ProfileZito ? 121553 : 0);
            this.checkinCall(paybookID);

        }

        // PushToast Exemple
        else if (notification.additionalData.tipo == TCentralTipo.ctFriendy) {

            this.util.toastSimply(notification.title + ' - ' + notification.message, 4000);

        }

        // PushAlert Exemple
        else if (notification.additionalData.tipo == TCentralTipo.ctHotspot) {

            this.util.alertQuestion(notification.title, notification.message, 'Ver', () => this.pageNavigate(notification.additionalData.queryString), false, false, notification.additionalData.cssClass);

        }

        // PushModal Exemple
        else if (notification.additionalData.tipo == TCentralTipo.ctChaveco) {

            notification.additionalData.objectData.etapa = 0;
            this.navCtrl.push(ChavecoMenuPage, notification.additionalData.objectData, {animate: false});

        }

        // PushNavigate Exemple
        //else if (notification.additionalData.tipo == TCentralTipo.XXX) {

        //    this.pageNavigate(notification.additionalData.queryString);

        //}

    }

    //Navigate: Browser, Push, Deeplink
    pageNavigate(queryString) {

        if (!queryString) return;


        //Limpa no DataService os Params do Get
        let datas = this.dataService.get();
        for (let i in datas) {
            this.dataService.set('param.' + i, null);
        }


        //Grava no DataService os Params do Get
        //params ex.: ?hotspotid=115199&convite=1 (hotspot, convite)
        let params = this.util.queryParse(queryString);
        for (let i in params) {
            this.dataService.set('param.' + i, params[i]);
        }


        //NICKNAMER - ex: localhost:8100/?thehistory
        let paramKey = '';
        let paramQtd = 0;
        for (let i in params) {
            paramQtd = paramQtd + 1;
            paramKey = i;
        }
        if (paramQtd == 1 && params[paramKey] == 'undefined') this.nicknamer = paramKey;


        //todo: MIDUKA PODEMOS DELETAR ISSO?
        //Grava no DataService os Params do Get
        //barras ex.: /hotspot/theweeksp/convite (param.0, param.1, param.2)
        //let paramsPath = this.util.paramParse();
        //for (let i in paramsPath) {
        //    this.dataService.set('param.' + i, paramsPath[i]);
        //}


        //Navega
        if (this.started) {

            if (this.logadoService.getAuth()) {
                this.navRepository.afterLogin(this.navCtrl, AFTER_LOGIN).subscribe();
            }
            else {
                this.navRepository.afterLogout(this.navCtrl, AFTER_LOGOUT).subscribe();
            }

        }

    }

    checkinCall(paybookID, _paybase: boolean = false, hotspotID: number = 0) {

        let logado = this.logadoService.getAuth();
        if (!logado) return;

        let onLoad = (paybook) => {

            //Limpar carrinho
            if ((paybook || {PaybookID: 0}).PaybookID != (this.appjson.checkin || {PaybookID: 0}).PaybookID) {
                console.log('Limpou');
                this.carbookService.setStart(null,null);
            }

            //Define checkin
            this.appjson.checkin = paybook;
            if (paybook) {
                this.appjson.checkin._paybase = _paybase;
            }


            if (!paybook) {
                this.appjson.changed = true;
            }

            if (paybook) {
                this.util.vibrate(10);
                this.carbookService.setStart(TCarsale.csPayout, {HotspotID: paybook.HotspotID, Branded: paybook.Branded});
                this.carbookService.paybookPush(paybook);
                this.appjson.changed = true;
            }

            this.messageService.get('checkin.call').next(this.appjson);

        };


        //Bridging...
        /*
        this.appjson.briding.searching = true;
        this.hotspotService.paybook(TAction.acGoin, paybookID, 0, 0, logado.Profile.ProfileID)
            .finally(() => {
                this.appjson.briding.searching = false;
                this.ngZone.run(() => {});
            })
            .subscribe(
                data => onLoad(data.Paybooks[0]),
                erro => {

                    if (this.appjson._firsterro) this.util.alertResult(erro);
                    this.appjson._firsterro = false;

                });
        */

        if (!hotspotID) return;
        let params = '&ComandaText=' + logado.Profile.ProfileRnid +
                     '&ComandaMode=' + TAcessoFind.afFindRnid;

        let loading = this.util.loadingDots();
        loading.present();

        this.util.monitorDesk(false, 'DESK-Comanda', hotspotID, params, TAction.acFind)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onLoad(data.Comandas[0]),
                erro => this.util.alertResult(erro));
        

    }

    hotpageCall() {

        let brandex = CONFIG.data.brandap;
        let hotspotID = brandex.HotspotID;
        let object = {hotspotID: hotspotID, brandex: brandex, tabmenu: false};
        this.app.getRootNavs()[0].setRoot(WebsiteSpotPage, object);

    }

    meritumCall() {

        let logado = this.logadoService.getAuth();
        let meritumID = this.dataService.get('param.meritumid');
        let profileID = this.util.anyParams((!logado ? 0 : logado.Profile.ProfileID), <number>this.dataService.get('param.profileid'));
        let rootile = {Profile: {ProfileID: profileID}};


        let loading = this.util.loadingDots();
        loading.present();

        let params = '&MeritumID=' + meritumID + '&ProfileID=' + profileID;
        this.logadoService.started(TAction.acTwin, null, params)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    if (!data.Meritums.length) return;

                    let meritum = data.Meritums[0];
                    let object = {etapa: 88, rootile: rootile, meritums: [meritum], produtoTipo: TProdutoTipo.ptNone};
                    this.util.modalopen(MeritumMenuPage, 'quad', true, object).subscribe(
                        data => this.navRepository.closePage(this.navCtrl, CLOSE_PAGE).subscribe()
                    );
                },
                erro => this.util.alertResult(erro)
            );

    }

}



// WEBPACK FOOTER //
// ./src/app/handapp-main/handapp-main.ts